<template>
  <el-form class="exrcise-form" ref="form" label-width="80px">
    <el-form-item label="课程">
      <LessonSelect v-model="model.plid"></LessonSelect>
    </el-form-item>
    <el-form-item label="题型">
      <el-select filterable v-model="model.tid" placeholder="请选择" class="exr-type-list" @change="handleTypeChanged">
        <el-option
          v-for="item in nativeTypes"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <div v-show="model.tid" style="color:#E6A23C;line-height:1.3;margin-top:3px;">注意：修改题型后会清空所有录入的数据，请谨慎操作！</div>
    </el-form-item>
    <component :is="template" :config="modelConfig" :model="model.data" ref="exr" class="exr-content-form"></component>
    <Help v-model="model.help"></Help>
    <el-form-item>
      <el-checkbox v-model="model.no_wrongs" :true-label="1" :false-label="0">不可加入错题集</el-checkbox>
    </el-form-item>
    <el-form-item label="知识点">
      <ExerciseKnow v-model="model.knows" :eid="model.id"></ExerciseKnow>
    </el-form-item>
  </el-form>
</template>

<script>
import xztForm from './../../../components/exercise//forms/XztForm'
import dctForm from './../../../components/exercise//forms/DctForm'
import xctkForm from './../../../components/exercise//forms/XctkForm'
import xktcForm from './../../../components/exercise//forms/XktcForm'
import pxtForm from './../../../components/exercise//forms/PxtForm'
import lytForm from './../../../components/exercise//forms/LytForm'
import xsdForm from './../../../components/exercise//forms/XsdForm'
import ExerciseKnow from './../../../components/exercise//ExerciseKnows'
import utils from './../../../js/utils'
import LessonSelect from './../LessonSelect'
import Help from './../../../components//HelpInlineForm.vue'

export default {
  name: 'ExerciseForm',
  components: { xztForm, dctForm, xctkForm, xktcForm, pxtForm, lytForm, xsdForm, ExerciseKnow, LessonSelect, Help },
  props: {
    types: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      typeList: [],
      model: {
        id: null,
        tid: null,
        level: 0,
        plid: null,
        no_wrongs: 0,
        data: {},
        status: 1,
        knows: [],
        help: {}
      },
      original: {
        knows: null
      }
    }
  },
  computed: {
    allowEditType () {
      return !!this.model.id
    },
    nativeTypes () {
      return this.typeList.length > 0 ? this.typeList : this.types
    },
    modelType () {
      return this.nativeTypes.find(val => val.id === this.model.tid)
    },
    template () {
      return this.modelType ? (this.modelType.template + 'Form') : null
    },
    modelConfig () {
      return this.modelType ? JSON.parse(this.modelType.data_json) : {}
    }
  },
  watch: {
    types: {
      handler () {
        this.types.length > 0 || this.fetchTypes()
      },
      immediate: true
    },
    "model.level" () {
      this.types.length > 0 || this.fetchTypes()
    }
  },
  methods: {
    reset (item) {
      item = Object.assign({
        id: null,
        tid: null,
        level: 0,
        plid: null,
        no_wrongs: 0,
        data_json: '',
        status: 1,
        knows: [],
        help: {}
      }, item)
      this.model.id = item.id
      //this.model.level = item.level
      this.model.plid = item.plid
      this.model.tid = item.tid
      this.model.no_wrongs = item.no_wrongs
      this.model.data = item.data_json ? JSON.parse(item.data_json) : {}
      this.model.status = item.status
      this.model.knows = item.knows
      this.model.help = item.help
      this.original.knows = item.knows ? [...item.knows] : []
    },
    getFormData () {
      let dels = []
      if (this.original.knows) {
        dels = this.original.knows.filter(n => {
          return !this.model.knows.some(k => {
            return k.id === n.id
          })
        })
        dels.forEach(n => {
          n.deleted = 1
        })
      }
      return {
        id: this.model.id,
        tid: this.model.tid,
        level: this.model.level,
        plid: this.model.plid,
        no_wrongs: this.model.no_wrongs,
        status: this.model.status,
        data: this.$refs.exr.form,
        knows: this.model.knows.concat(dels),
        help: this.model.help
      }
    },
    submit () {
      var params = utils.filterData(this.getFormData())
      if (this.model.id) {
        delete params.id
        return this.$http.put(this.$urls.pinyin_exercise_update, params, {
          params: { id: this.model.id }
        })
      } else {
        return this.$http.post(this.$urls.pinyin_exercise_create, params).then(data => {
          this.model.id = data.id
        })
      }
    },
    fetchTypes () {
      return this.$http.get(this.$urls.exercise_type_list, {
        params: { 
          'filter[level]': 0,
          'sort': 'name',
          page: 1, 
          'per-page': 1000 
        }
      }).then(res => {
        this.typeList = res.data
      })
    },
    handleTypeChanged () {
      this.model.data = {}
    }
  }
}
</script>

<style lang="scss">
.exrcise-form{
  .exr-type-list{
    width: 100%;
  }
}
</style>
